import { useMutation, useQueryClient } from '@tanstack/react-query';
import ContractTemplateService, {
  ICreateContractTemplateParams,
} from '@clickersphere/core/services/ContractTemplateService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import {
  ContractTemplateQueryData,
  CONTRACT_TEMPLATES_QUERY_KEY,
} from './useContractTemplates';

export function useCreateContractTemplate() {
  const queryClient = useQueryClient();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    isPending: createContractTemplateIsPending,
    mutateAsync: createContractTemplateAsync,
  } = useMutation({
    mutationFn: async (data: ICreateContractTemplateParams) =>
      ContractTemplateService.create(data),
    onSuccess: async (created) => {
      await queryClient.cancelQueries({
        queryKey: buildQueryKey(CONTRACT_TEMPLATES_QUERY_KEY),
      });

      queryClient.setQueryData<ContractTemplateQueryData[]>(
        buildQueryKey(CONTRACT_TEMPLATES_QUERY_KEY),
        (old) => (old ? [...old, created] : [created]),
      );
    },
  });

  return {
    createContractTemplateAsync,
    createContractTemplateIsPending,
  };
}
